import { createFileRoute } from "@tanstack/react-router";
import { categoryRouteOptions } from "@/lib/categoryLandingRoute";

export const Route = createFileRoute("/travel-trailers")(categoryRouteOptions("travel-trailers"));
